<app-page-headline
        [breadcrumbTitle]="'Features'"
        [breadcrumbs]="[
        { label: 'Features', link: '/tabellen' },
        { label: 'Spalten Übersicht', iconClass: 'fa fa-angle-double-right', link: '/tabellen/generieren' }
            ]"
        [mainTitle]="'Unsere Datenkategorien im Überblick'"
        [subtitle]="'Unsere Plattform bietet Ihnen nicht nur Zugang zu umfangreichen Firmeninformationen und geprüften E-Mail-Adressen – Sie erhalten maßgeschneiderte Listen, die genau auf Ihre Bedürfnisse abgestimmt sind. Nutzen Sie unseren flexiblen Listen-Konfigurator, um gezielt nach Branche, Standort oder Bundesland zu filtern und so nur die Kontakte zu erhalten, die für Sie wirklich relevant sind.'"
        [titleImagePath]="'assets/images/saas1/title-logo.png'"
        [backgroundImage]="'assets/images/saas1/work-bg.png'">
</app-page-headline>
<app-two-split-legal-section></app-two-split-legal-section>
<app-two-split-image-bullet-points-section></app-two-split-image-bullet-points-section>




